import { render, staticRenderFns } from "./ComfirmModal.vue?vue&type=template&id=313ab810&scoped=true&"
import script from "./ComfirmModal.vue?vue&type=script&lang=js&"
export * from "./ComfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmModal.vue?vue&type=style&index=0&id=313ab810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ab810",
  null
  
)

export default component.exports